var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({attrs:{"rounded":"","outlined":_vm.outlined,"color":"primary","disabled":_vm.disabled,"loading":_vm.loading,"min-width":_vm.minWidth}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.buttonName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }